/* eslint-disable import/no-named-as-default-member */
import React, { useEffect, useState } from 'react';
import {
  Monitor as MonitorIcon,
  RefreshCw,
  Smartphone as PhoneIcon,
} from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  BackButton,
  CardMOList,
  DaySpotAndRangePicker,
  Error,
  Loading,
  ManufacturingOrderExportExcelContainer,
  ManufacturingOrderTable,
  NameBox,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import {
  ManufacturingOrderColumn,
  ManufacturingOrderWithProcessColumn,
} from '@iarc-programing/emanufac-utils/columns';
import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import dayjs from 'dayjs';
import { gql } from 'graphql-request';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { config } from '@/configs';
import graphqlClient from '@/configs/graphqlClient';
import * as actions from '@/redux/actions';
import * as CONSTANT from '@/utils/constants';
import { useQuery } from '@/utils/functions';

/**
 * @function ManufactoringOrderBySales
 */
function ManufacturingOrderBySales({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const manufacturingOrder = useSelector((state) => state.manufacturingOrder);
  const information = useSelector((state) => state.information);
  const employee = useSelector((state) => state.employee);
  const params = useParams();
  const salesId = params.id;

  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(undefined);
  const [fullDataMO, setFullDataMO] = useState(null);
  const [useRedis, setIsUseRedis] = useState(true);
  const [selectedView, setSelectedView] = useState(
    window.screen.width >= 768
      ? CONSTANT.DISPLAY_TYPE.TABLE.status_code
      : CONSTANT.DISPLAY_TYPE.CARD.status_code,
  );
  const browserQuery = useQuery();
  const [startDate, setStartDate] = useState(browserQuery.get('startDate'));
  const [endDate, setEndDate] = useState(browserQuery.get('endDate'));
  const [orderByField, setOrderByField] = useState('createdAt');
  const [orderBy, setOrderBy] = useState('desc');

  useEffect(() => {
    dispatch(actions.manufacturingOrderReset());

    return () => {};
  }, []);

  const query = gql`
    query FindManufacturingOrder($input: ManufacturingOrderInput) {
      findManufacturingOrders(input: $input) {
        currPage
        lastPage
        total
        rows {
          _id
          id
          assigner {
            firstname
            lastname
          }
          prefix
          running_number
          customer {
            type_code
            name
            address
            phone_number
            rating
          }
          quotation {
            _id
            running_number
            sales {
              firstname
              lastname
            }
          }
          process {
            product {
              type_code
              name
            }
            produce_material_instead
            produce_base_project_instead
            base_project {
              type_code
              name
              unit
            }
            product_as_material {
              type_code
              name
            }
            current {
              index
              step {
                name
              }
            }
            current_step_name
            customer {
              type_code
              name
            }
            other_customers {
              name
            }
            quantity
            price_per_unit
            additional_unit
            remark
          }
          discount
          completed
          deleted
          start_date
          expected_date
          remark
          status
          is_claimed
        }
      }
    }
  `;

  const queryDataFromServer = async () => {
    try {
      const queryResult = await graphqlClient.request(query, {
        input: {
          page,
          size,
          name,
          enableFetchInside: false,
          fetchCurrentStep: false,
          fetchCustomer: false,
          fetchMaterial: false,
          fetchProduct: false,
          stage: undefined,
          fetchProcess: false,
          forceWithoutCache: !useRedis,
          startDate: dayjs(startDate).format('YYYY-MM-DD'),
          endDate: dayjs(endDate).format('YYYY-MM-DD'),
          includeLog: true,
          orderByField,
          orderBy,
          claimed: undefined,
          sales: salesId,
        },
      });

      const manufacturingOrderData = queryResult?.findManufacturingOrders;

      dispatch(actions.manufacturingOrderStateSet(manufacturingOrderData));
    } catch (err) {
      console.error('Mo,  Have an errors');
      dispatch(actions.manufacturingOrderReset());
    }
  };

  const callInsideFunction = async () => {
    try {
      console.log('Call Function Inside');
      const insideQuery = await graphqlClient.request(query, {
        input: {
          page,
          size,
          name,
          enableFetchInside: false,
          fetchCurrentStep: false,
          fetchCustomer: true,
          fetchMaterial: true,
          fetchProduct: true,
          fetchBaseProject: true,
          stage: undefined,
          fetchProcess: true,
          forceWithoutCache: !useRedis,
          startDate: dayjs(startDate).format('YYYY-MM-DD'),
          endDate: dayjs(endDate).format('YYYY-MM-DD'),
          includeLog: true,
          orderByField,
          orderBy,
          claimed: undefined,
          sales: salesId,
        },
      });

      const insidedQueryResult = insideQuery?.findManufacturingOrders;
      setFullDataMO(insidedQueryResult);
    } catch (error) {
      console.error(error?.message);
      dispatch(actions.manufacMaterialError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    console.log('Waiting for time to fetch inside');
    const fetchInsideTimeout = setTimeout(() => {
      callInsideFunction();
    }, 1000);
    return () => {
      console.log('Clear Fetch inside Timeout');
      clearTimeout(fetchInsideTimeout);
    };
  }, [name, page, size, useRedis, startDate, endDate, orderByField, orderBy]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    setTotal(manufacturingOrder?.total);
    return () => {};
  }, [manufacturingOrder]);

  useEffect(() => {
    console.log('Full Data MOs is Toggle');
    if (fullDataMO && manufacturingOrder?.rows) {
      dispatch(actions.manufacturingOrderStateSet(fullDataMO));
    } else {
      console.log('แฮ่ แกเซ็ทไม่ได้หรอก');
    }
    return () => {};
  }, [fullDataMO]);

  useEffect(() => {
    dispatch(actions.employeeGet(salesId));

    return () => {};
  }, [params]);

  const moQueryAPI = {
    page: 1,
    size: config.maxFetchSize,
    name: '',
    enableFetchInside: '',
    fetchCurrentStep: '',
    fetchCustomer: true,
    fetchMaterial: true,
    fetchProduct: true,
    fetchBaseProject: true,
    stage: '',
    fetchProcess: true,
    forceWithoutCache: true,
    startDate: dayjs(startDate).format('YYYY-MM-DD'),
    endDate: dayjs(endDate).format('YYYY-MM-DD'),
    status: '',
    includeLog: true,
    orderByField,
    orderBy,
    claimed: '',
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row justify-between">
        <div className="w-8/12 md:w-5/12">
          <TextField
            label="ค้นหา"
            fullWidth
            size={'small'}
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="lg:w-3/12"></div>
        <div className="lg:w-2/12 px-1 md:w-2/12 justify-self-end">
          <ManufacturingOrderExportExcelContainer
            sheetName={`ManufacturingOrder-Sales-${employee?.firstname}-${dayjs(
              startDate,
            ).format('YYYY-MM-DD')}-${dayjs(endDate).format(
              'YYYY-MM-DD',
            )}-Export`}
            dataQuery={moQueryAPI}
            currentData={manufacturingOrder?.rows}
            dataAPIEndPoint="manufacturing-order"
            columnList={ManufacturingOrderColumn(information)}
            processColumnList={ManufacturingOrderWithProcessColumn(information)}
          />
        </div>
        <div className="w-1/12 px-1 flex justify-end">
          <ToggleButtonGroup
            value={selectedView}
            exclusive
            size="small"
            onChange={(event, value) => setSelectedView(value)}
          >
            <ToggleButton value={CONSTANT.DISPLAY_TYPE.TABLE.status_code}>
              <MonitorIcon size="16" />
            </ToggleButton>
            <ToggleButton value={CONSTANT.DISPLAY_TYPE.CARD.status_code}>
              <PhoneIcon size="16" />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
    </Card>
  );

  const handleToInfoPage = (id) => {
    history.push(`manufacturing-orders/view/${id}`);
  };

  const handlePushToEditPage = (id) => {
    history.push(`manufacturing-orders/edit/${id}`);
  };

  const handleToDistributeMaterial = (id) => {
    history.push(`material-distribute/${id}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleCreateProductionLine = (manufacOrderId, productId) => {
    history.push(`create-production-line/${manufacOrderId}/${productId}`);
  };

  const tableProps = {
    handleChangePage,
    handleChangeRowsPerPage,
    handleCreateProductionLine,
    handleDelete: () => {},
    handlePushToEditPage,
    handleToDistributeMaterial,
    handleToInfoPage,
    manufacturingOrder,
    page,
    size,
    total,
    orderByField,
    orderBy,
    setOrderByField,
    setOrderBy,
    displayCancleButton: false,
    showSales: true,
    showInsideStatus: false,
  };

  const renderTable = () => (
    <div>
      {selectedView === CONSTANT.DISPLAY_TYPE.TABLE.status_code ? (
        <ManufacturingOrderTable {...tableProps} />
      ) : (
        <CardMOList {...tableProps} />
      )}
    </div>
  );

  const renderActionButton = () => (
    <div className="flex flex-row justify-end pb-4 gap-1">
      <Link
        to={`/spm/quotation/by-sales/${params.id}?startDate=${dayjs(
          startDate,
        ).format('YYYY-MM-DD')}&endDate=${dayjs(endDate).format('YYYY-MM-DD')}`}
      >
        <Button variant="contained" color="secondary">
          ใบเสนอราคาตามพนักงาน
        </Button>
      </Link>
      <Button
        variant="contained"
        color="teal"
        startIcon={<RefreshCw size={16} />}
        onClick={() => {
          setIsUseRedis(false);
        }}
      >
        รีเฟรช
      </Button>
    </div>
  );

  if (manufacturingOrder?.isLoading) {
    return <Loading />;
  }

  if (!manufacturingOrder?.isLoading && manufacturingOrder?.isCompleted) {
    return (
      <div>
        <div className="flex justify-between">
          <div>{renderTitle()}</div>
          <div className="mt-6">{renderActionButton()}</div>
        </div>

        <div className="my-2">
          <BackButton />
        </div>

        <Card className="my-2">
          <CardContent>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-1/3">
                <div className="font-semibold">
                  <NameBox user={employee} showDepartment />
                </div>
                <div>
                  ตั้งแต่วันที่ {dayjs(startDate).format('D MMMM BBBB')}{' '}
                  ถึงวันที่ {dayjs(startDate).format('D MMMM BBBB')}{' '}
                </div>
              </div>
              <div className="w-full lg:w-2/3">
                <DaySpotAndRangePicker
                  enable
                  flex
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  endDate={endDate}
                  size="small"
                  defaultUseRange
                />
              </div>
            </div>
          </CardContent>
        </Card>
        {renderSearch()}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
}

ManufacturingOrderBySales.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ManufacturingOrderBySales.defaultProps = {
  title: '',
  subtitle: '',
};

export default ManufacturingOrderBySales;
